import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { createContext, useContext } from 'react';
export const DEFAULT_SIDE_CONTENT_WIDTH_PX = 720;
const COMPACT_SIDE_CONTENT_WIDTH_PX = 400;
export const INITIAL_STATE = Object.freeze({
    tab: undefined,
    citations: undefined,
    checkSources: undefined,
    councilResponse: undefined,
    claimsPanel: undefined,
    datavizPanel: undefined,
    computerArtifactPanel: undefined,
    financeTaxLotsPanel: undefined,
});
function openTab(action) {
    switch (action.tabType) {
        case 'citations':
            return {
                ...INITIAL_STATE,
                tab: { name: 'citations', resizable: false, widthPx: COMPACT_SIDE_CONTENT_WIDTH_PX },
                citations: action.citations,
            };
        case 'check_sources':
            return {
                ...INITIAL_STATE,
                tab: { name: 'check_sources', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
                checkSources: action.checkSources,
            };
        case 'canvas':
            return {
                ...INITIAL_STATE,
                tab: { name: 'canvas', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
            };
        case 'pdf':
            return {
                ...INITIAL_STATE,
                tab: { name: 'pdf', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
            };
        case 'file_preview':
            return {
                ...INITIAL_STATE,
                tab: { name: 'file_preview', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
            };
        case 'council_response':
            return {
                ...INITIAL_STATE,
                tab: { name: 'council_response', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
                councilResponse: action.councilResponse,
            };
        case 'claims':
            return {
                ...INITIAL_STATE,
                tab: { name: 'claims', resizable: false, widthPx: COMPACT_SIDE_CONTENT_WIDTH_PX },
                claimsPanel: action.claimsPanel,
            };
        case 'dataviz':
            return {
                ...INITIAL_STATE,
                tab: { name: 'dataviz', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
                datavizPanel: action.datavizPanel,
            };
        case 'computer_artifact':
            return {
                ...INITIAL_STATE,
                tab: { name: 'computer_artifact', resizable: true, widthPx: DEFAULT_SIDE_CONTENT_WIDTH_PX },
                computerArtifactPanel: action.computerArtifactPanel,
            };
        case 'finance_tax_lots':
            return {
                ...INITIAL_STATE,
                tab: {
                    name: 'finance_tax_lots',
                    resizable: false,
                    widthPx: COMPACT_SIDE_CONTENT_WIDTH_PX,
                },
                financeTaxLotsPanel: action.financeTaxLotsPanel,
            };
        default:
            return assertUnreachableValue(action);
    }
}
export function sideContentReducer(state, action) {
    switch (action.action) {
        case 'open':
            return openTab(action);
        case 'close':
            return action.tabType && state.tab?.name !== action.tabType ? state : INITIAL_STATE;
        case 'updateCheckSources':
            if (!state.checkSources)
                return state;
            return { ...state, checkSources: { ...state.checkSources, ...action.checkSources } };
        case 'update':
            switch (action.tabType) {
                case 'claims': {
                    const base = state.claimsPanel ?? { claims: [] };
                    return { ...state, claimsPanel: { ...base, ...action.claimsPanel } };
                }
                default:
                    return assertUnreachableValue(action);
            }
        default:
            return assertUnreachableValue(action);
    }
}
export const Context = createContext({
    ...INITIAL_STATE,
    dispatch: () => null,
});
Context.displayName = 'SideContentContext';
export function useSideContent() {
    return useContext(Context);
}
//# sourceMappingURL=ProviderShared.js.map